import * as React from 'react';
import { observer } from 'mobx-react-lite';

import styles from './LiveNotification.scss';

/**
 * Props for LiveNotification component
 */
export interface LiveNotificationProps {
    /**
     * Message to be read by screen readers
     */
    message: string;

    /**
     * Whether all changes to the component should be re-read by screenreaders.
     * True if all changes should be re-read; false otherwise
     */
    atomic: boolean;

    /**
     * Polite alerts wait until the screen reader is not busy to make the announcement, and are not
     * guaranteed to announce. Assertive alerts will stop whatever announcements are in progress to
     * make their announcement
     */
    announcementType?: 'assertive' | 'polite';
}

/**
 * Component to send live notification messages to screenreaders
 */
export const LiveNotification = observer(function LiveNotification(props: LiveNotificationProps) {
    const { message, atomic, announcementType = 'polite' } = props;

    return (
        <div aria-live={announcementType} aria-atomic={atomic} className={styles.alert}>
            <span>{message}</span>
        </div>
    );
});
